export default {"src":"/_next/static/media/doghouse_40.96739600.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};